// @owma/common-web/utils/ui/SecureSend/BlockedBanner
// 출처: apps/owma/src/utils/ui/SecureSend/BlockedBanner.tsx
// 변경: import 경로를 common-web 상대경로/bare i18next 로 조정.
import classNames from 'classnames'
import i18n from 'i18next'

import { SVGImageCurrentColor } from '../../svgHelper'
import toolbarSecureSend from '../../../assets/images/toolbar-secure-send.svg'

import styles from './style.module.scss'

interface BlockedBannerProps {
  onRenewAccess: () => void
}

const BlockedBanner = ({ onRenewAccess }: BlockedBannerProps) => {
  return (
    <div className={classNames(styles.secureBanner)}>
      <div
        className={classNames(styles.secureBannerIcon)}
        style={{ color: '#FD4C45', width: 20, height: 20 }}
      >
        <SVGImageCurrentColor src={toolbarSecureSend} alt="secure send" />
      </div>
      <div className={classNames(styles.secureBannerMessages)}>
        <span className={classNames(styles.secureBannerTitle)}>{i18n.t('secureSend.blocked')}</span>
        <span className={classNames(styles.secureBannerDesc)}>
          {i18n.t('secureSend.blockedDesc')}
        </span>
      </div>
      <div className={classNames(styles.secureBannerButtons)}>
        <button type="button" onClick={onRenewAccess}>
          {i18n.t('secureSend.renewAccess')}
        </button>
      </div>
    </div>
  )
}

export default BlockedBanner
